module.exports = __webpack_public_path__ + "img/certificate11.f337ba0e.jpg";